import type { Rule } from "antd/es/form"

export const validateAppVersionFormat = (_: Rule, value: string) => {
  if (!value || value.trim() === "") {
    return Promise.resolve()
  }

  const trimmed = value.trim()

  // Support both 3-part (1.2.3) and 4-part (1.2.3.0) versions
  const versionRegex = /^\d+\.\d+\.\d+(\.\d+)?$/

  if (!versionRegex.test(trimmed)) {
    return Promise.reject(new Error("Version must be in format X.Y.Z or X.Y.Z.W (e.g., 1.2.3 or 1.2.3.0)"))
  }

  const parts = trimmed.split(".")

  // Check each part is a valid number (no excessive leading zeros)
  for (const part of parts) {
    const num = parseInt(part, 10)
    if (num < 0) {
      return Promise.reject(new Error("Version numbers cannot be negative"))
    }
    // Check for excessive leading zeros (except for "0")
    if (part.length > 1 && part.startsWith("0")) {
      return Promise.reject(new Error("Version parts cannot have leading zeros"))
    }
  }

  return Promise.resolve()
}
